/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Top_Performers_TodayInputs */

const th_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้เล่นยอดเยี่ยม · วันนี้`)
};

const en_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top performers · today`)
};

const ja_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本日の活躍選手`)
};

const zh_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日最佳表现`)
};

const es_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacados · hoy`)
};

const pt_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destaques · hoje`)
};

const id_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penampilan terbaik · hari ini`)
};

const fr_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleures performances · aujourd’hui`)
};

const tl_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakamagagaling · ngayon`)
};

const vi_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Màn trình diễn hay nhất · hôm nay`)
};

const ko_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오늘의 활약`)
};

const de_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beste Leistungen · heute`)
};

const ru_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучшие сегодня`)
};

const tr_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günün en iyileri`)
};

const it_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliori prestazioni · oggi`)
};

const pl_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepsi dzisiaj`)
};

const uk_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найкращі сьогодні`)
};

const hi_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आज के श्रेष्ठ प्रदर्शन`)
};

const ar_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أفضل الأداءات · اليوم`)
};

const ms_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persembahan terbaik · hari ini`)
};

const bn_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আজকের সেরা পারফরম্যান্স`)
};

const zh_tw2_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日最佳表現`)
};

const zh_hk2_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日最佳表現`)
};

const ur_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آج کی بہترین کارکردگی`)
};

const fa_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بهترین‌های امروز`)
};

const sw_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waliofanya vizuri zaidi · leo`)
};

const nl_top_performers_today = /** @type {(inputs: Top_Performers_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beste prestaties · vandaag`)
};

/**
* | output |
* | --- |
* | "Top performers · today" |
*
* @param {Top_Performers_TodayInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const top_performers_today = /** @type {((inputs?: Top_Performers_TodayInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Top_Performers_TodayInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_top_performers_today(inputs)
	if (locale === "ja") return ja_top_performers_today(inputs)
	if (locale === "zh") return zh_top_performers_today(inputs)
	if (locale === "es") return es_top_performers_today(inputs)
	if (locale === "pt") return pt_top_performers_today(inputs)
	if (locale === "id") return id_top_performers_today(inputs)
	if (locale === "fr") return fr_top_performers_today(inputs)
	if (locale === "tl") return tl_top_performers_today(inputs)
	if (locale === "vi") return vi_top_performers_today(inputs)
	if (locale === "ko") return ko_top_performers_today(inputs)
	if (locale === "de") return de_top_performers_today(inputs)
	if (locale === "ru") return ru_top_performers_today(inputs)
	if (locale === "tr") return tr_top_performers_today(inputs)
	if (locale === "it") return it_top_performers_today(inputs)
	if (locale === "pl") return pl_top_performers_today(inputs)
	if (locale === "uk") return uk_top_performers_today(inputs)
	if (locale === "hi") return hi_top_performers_today(inputs)
	if (locale === "ar") return ar_top_performers_today(inputs)
	if (locale === "ms") return ms_top_performers_today(inputs)
	if (locale === "bn") return bn_top_performers_today(inputs)
	if (locale === "zh-TW") return zh_tw2_top_performers_today(inputs)
	if (locale === "zh-HK") return zh_hk2_top_performers_today(inputs)
	if (locale === "ur") return ur_top_performers_today(inputs)
	if (locale === "fa") return fa_top_performers_today(inputs)
	if (locale === "sw") return sw_top_performers_today(inputs)
	if (locale === "nl") return nl_top_performers_today(inputs)
	return en_top_performers_today(inputs)
});